import { memo } from "react"

const TrucoTimer = memo(({ duration = 1, remaining = 0, x = 0, y = 0 }) => {

    const percentage = Math.max(
        0,
        Math.min(100, (remaining / duration) * 100)
    )

    return (
        <div
            className="truco-timer-main"
            style={{ transform: `translate(${x}px, ${y}px)` }}
        >
            <div
                className="truco-progress-bar"
                role="progressbar"
                aria-valuemin="0"
                aria-valuemax="100"
                aria-valuenow={percentage}
            >
                <div
                    className="truco-progress__bar"
                    style={{ width: `${percentage}%` }}
                />
            </div>
        </div>
    )
})

export default TrucoTimer